export const PAYMENT_METHOD_DIRECT_DEBIT = 1
export const PAYMENT_METHOD_MANUAL_TRANSFER = 2

export type PaymentMethod =
    | typeof PAYMENT_METHOD_DIRECT_DEBIT
    | typeof PAYMENT_METHOD_MANUAL_TRANSFER

/**
 * Mandate confirmed by the provider, or created already pre-signed. Invoicing treats this as chargeable.
 * collections-only mandate can stay active here.
 */
export const SUBSCRIPTION_STATUS_ACTIVE = 'active'

/** Mandate revoked at Mollie. The external mandate id is cleared. */
export const SUBSCRIPTION_STATUS_CANCELLED = 'cancelled'

/** Mandate created, still waiting for the confirmation mail. mandate_accepted is empty. */
export const SUBSCRIPTION_STATUS_UNVERIFIED = 'unverified'

export type SubscriptionStatus =
    | typeof SUBSCRIPTION_STATUS_ACTIVE
    | typeof SUBSCRIPTION_STATUS_CANCELLED
    | typeof SUBSCRIPTION_STATUS_UNVERIFIED

export interface PaymentInfo {
    payment_info_id: number
    service_provider_id: number
    gender: 0 | 1 | 2
    first_name: string
    last_name: string
    business_name: string | null
    street: string | null
    postal_code: string | null
    city: string | null
    country_code: string
    house_number: string | null
    house_number_add: string | null
    bank_tnv: string | null
    iban: string | null
    bic: string | null
    vat: string | null
    cif_nif_nie: string | null
    vat_state: number
    vat_checked_at: string | null
    vat_consultation_number: string | null
    mandate_id: string | null
    sepa_status: string | null
    payment_method: PaymentMethod
    active: boolean
    created: string
    customer_mandate_id: string | null
    exact_imported_batch: number | null
    exact_update_pending: string | null
    mandate_exported_batch: number | null
    email: string | null
    mandate_accepted: string | null
    subscription_status: SubscriptionStatus | null
    external_customer_id: string | null
    mollie_mandate_id: number | null
    subscription_status_last_updated: string | null
    use_franchise_billing: boolean
    external_mandate_id: string | null
    external_collector_id: string | null
    credit_limit_cleared: number
    mandate_status: 'active' | 'collections_only' | 'revoked' | 'archived' | null
    mandate_churn_date: string | null
    mandate_churn_reason: string | null
}
